import { Box, Card, Link, Typography } from '@material-ui/core';
import React from 'react';
import { publish } from 'pubsub-js';
import styles from './style';

/**
 * @name HelpCentreServiceCard
 * @param {*} props - react props
 * @returns {JSX.Element} - Renders Help centre services card component
 */
const HelpCentreServiceCard = props => {
    const classes = styles();
    return (
        <Box style={{ flexGrow: '1', display: 'flex' }}>
            <Card className={classes.card}>
                <Box className={classes.cardInfo}>
                    <Box component='img' src={props?.icon} className={classes.mobileIcon} />
                    <Typography variant='h5' className={'title'}>
                        {props?.title}
                    </Typography>
                    <Box style={{ paddingTop: '15px' }}>
                        {props?.links.map(link => (
                            <Box className={link && classes.serviceDetails}>
                                <Link
                                    href={link?.url}
                                    className='link'
                                    onClick={() => {
                                        publish(link?.action);
                                    }}
                                >
                                    <Typography variant='body1'>{link?.name}</Typography>
                                </Link>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Card>
        </Box>
    );
};

export default HelpCentreServiceCard;
